<!-- Spalte statt fester Leisten: der Header ist hoeher als die alte Leiste,
     nur der Inhalt darunter scrollt. -->
<div class="voucher-frame">
  <app-header
    class="voucher-header"
    [showSearch]="false"
    [showGreeting]="false"
    [profileClickable]="false"
    [subtitle]="'PAGES.VOUCHER.HEADER' | translate"
  ></app-header>

  <!-- Eigene Leiste statt eines Links im Inhalt: der Ausgang gehoert zur
       Seitenchrome und steht damit in allen vier Schritten an derselben Stelle. -->
  <div class="voucher-backbar">
    <app-text-button
      class="voucher-back"
      icon="icons/24/arrow-left.svg"
      [label]="'PAGES.VOUCHER.BACK_TO_DASHBOARD' | translate"
      (action)="goToDashboard()"
    ></app-text-button>
  </div>

  <!-- Immer sichtbar: der Stepper haengt wie die Zurueck-Leiste am Rahmen und
       ueberlebt damit den Wechsel zwischen den Schritten. -->
  <div class="voucher-stepper">
    <app-stepper [steps]="STEPS" [current]="step"></app-stepper>
  </div>

  <div class="container">
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<!-- ⚠ Ausserhalb des Containers: das Overlay legt sich ueber den ganzen
     Bildschirm und wuerde sonst am Seitenrand haengen. -->
<app-confirm-modal
  [(open)]="showLeaveConfirm"
  [title]="'PAGES.VOUCHER.LEAVE.TITLE' | translate"
  [text]="'PAGES.VOUCHER.LEAVE.TEXT' | translate"
  [confirmLabel]="'PAGES.VOUCHER.LEAVE.CONFIRM' | translate"
  [dismissLabel]="'PAGES.VOUCHER.LEAVE.DISMISS' | translate"
  (confirmed)="leave()"
></app-confirm-modal>
